import Head from "next/head";
import styles from "@/styles/Home.module.css";
import { ComponentSettings } from "@/components/ui/Screens/Account";
import { RouteGuard } from "@/components/RouteGuard";

export default function AccountSettings() {
	return (
		<div className={styles.container}>
			<Head>
				<title>{"Settings & Alerts"}</title>
				<link rel="icon" href="/favicon.ico" />
				<meta
					property="og:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					name="twitter:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					name="description"
					content="Michigan's top rated private jet charter services, arrive on time and in style, service to the continental United States, call us for private or business travel services."
				></meta>
			</Head>

			<main
				style={{
					padding: 0,
					width: "100%",
					minHeight: "100vh",
				}}
			>
				<RouteGuard>
					<ComponentSettings />
				</RouteGuard>
			</main>
		</div>
	);
}
